import { render, staticRenderFns } from "./wtGifAsset.component.vue?vue&type=template&id=2d2b4794&"
import script from "./wtGifAsset.component.vue?vue&type=script&lang=js&"
export * from "./wtGifAsset.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports